import { Box } from '@material-ui/core';

import { AbstractProcessingStrategyEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/_shared/components/ProcessingStrategy/entities/ProcessingStrategy/AbstractProcessingStrategyEntity';
import { WaterfallProcessingStrategyEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/_shared/components/ProcessingStrategy/entities/ProcessingStrategy/WaterfallProcessingStrategyEntity';
import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';

interface ProcessingStrategySummaryProps {
  processingStrategyEntity: AbstractProcessingStrategyEntity;
}

export const ProcessingStrategySummary = ({ processingStrategyEntity }: ProcessingStrategySummaryProps) => {
  const isWaterfall = processingStrategyEntity instanceof WaterfallProcessingStrategyEntity;
  const isManualProcessingMode = processingStrategyEntity.isManualProcessingMode();
  const isSingleLender = (processingStrategyEntity.loanApplications?.length ?? 0) === 1;

  const titleId = isSingleLender
    ? 'PROCESSING_SUMMARY_SINGLE'
    : !isWaterfall
    ? 'PROCESSING_SUMMARY_PARALLEL'
    : isManualProcessingMode
    ? 'PROCESSING_SUMMARY_WATERFALL_MANUAL'
    : 'PROCESSING_SUMMARY_WATERFALL_AUTOMATIC';

  const textId = isSingleLender
    ? `PROCESSING_SUMMARY_SINGLE_${isManualProcessingMode ? 'MANUAL' : 'AUTOMATIC'}_TEXT`
    : `${titleId}_TEXT`;

  return (
    <Box mb={4}>
      <Font variant="subtitle2" display="block">
        <Text strong tId={titleId} />
      </Font>
      <Font variant="body2" display="block" color="textSecondary">
        <Text tId={textId} />
        {isWaterfall && !isManualProcessingMode && !isSingleLender && (
          <>
            {' '}
            <Text tId={`PROCESSING_SUMMARY_STOP_${processingStrategyEntity.getStopCondition()}`} />
          </>
        )}
      </Font>
    </Box>
  );
};
